const base = process.env.PUBLIC_URL || "";

export async function getVisualize(valueFilter, numFilter, subType) {
  const vf = String(valueFilter).toLowerCase();
  const n = String(numFilter);
  const st = String(subType).toLowerCase();
  const url = `${base}/data/visualize/visualize_${vf}_${n}_${st}.json`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to load ${url}`);
  }
  return res.json();
}
